import moment from "moment";
import { ja } from "vuejs-datepicker/dist/locale";
import { DateUtil } from "@/utils";

// 過去日を選択不可にする
const _pastDays = {
  disabledDates: {
    to: new Date()
  }
};

export default {
  data() {
    return {
      pastDays: _pastDays,
      ja: ja
    };
  },
  methods: {
    formatter(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    formatter_JP(date) {
      return moment(date).format("YYYY年MM月DD日");
    },
    customizeExpirationDateElement(datePickerElement) {
      const matchPattern = new RegExp('([0-9]{2,4})[/-年]([0-9]{1,2})[/-月]([0-9]{1,2})[日]?');
      const el = datePickerElement.querySelector('input');
      if (!el) {
        return;
      }
  
      this.$nextTick(() => {
        const groupMatch = el.value.match(matchPattern);
        if ( groupMatch && groupMatch.length > 3 ) {
          el.value = `${groupMatch[1]}年${groupMatch[2]}月${groupMatch[3]}日`;
        }
      });
      el.addEventListener("blur", (_) => {
        const groupMatch = el.value.match(matchPattern);
        if ( groupMatch && groupMatch.length > 3 ) {
          el.value = `${groupMatch[1]}年${groupMatch[2]}月${groupMatch[3]}日`;
        }
      });
  
      el.addEventListener("focus", (_) => {
        const groupMatch = el.value.match(matchPattern);
        if ( groupMatch && groupMatch.length > 3 ) {
          this.localData.expirationDate = DateUtil.toYMD(`${groupMatch[1]}-${groupMatch[2]}-${groupMatch[3]}`);
        }
      });
      el.addEventListener("change", (_) => {
        const groupMatch = el.value.match(matchPattern);
        if ( groupMatch && groupMatch.length > 3 ) {
          this.localData.expirationDate = DateUtil.toYMD(`${groupMatch[1]}-${groupMatch[2]}-${groupMatch[3]}`);
        }
      });
    },
  },
};
